/**
 * Do not edit directly
 * Generated on Thu, 06 Feb 2025 15:20:12 GMT
 */

export const cinnamon100 = "--cnvs-base-palette-cinnamon-100";
export const cinnamon200 = "--cnvs-base-palette-cinnamon-200";
export const cinnamon300 = "--cnvs-base-palette-cinnamon-300";
export const cinnamon400 = "--cnvs-base-palette-cinnamon-400";
export const cinnamon500 = "--cnvs-base-palette-cinnamon-500";
export const cinnamon600 = "--cnvs-base-palette-cinnamon-600";
export const peach100 = "--cnvs-base-palette-peach-100";
export const peach200 = "--cnvs-base-palette-peach-200";
export const peach300 = "--cnvs-base-palette-peach-300";
export const peach400 = "--cnvs-base-palette-peach-400";
export const peach500 = "--cnvs-base-palette-peach-500";
export const peach600 = "--cnvs-base-palette-peach-600";
export const chiliMango100 = "--cnvs-base-palette-chili-mango-100";
export const chiliMango200 = "--cnvs-base-palette-chili-mango-200";
export const chiliMango300 = "--cnvs-base-palette-chili-mango-300";
export const chiliMango400 = "--cnvs-base-palette-chili-mango-400";
export const chiliMango500 = "--cnvs-base-palette-chili-mango-500";
export const chiliMango600 = "--cnvs-base-palette-chili-mango-600";
export const cantaloupe100 = "--cnvs-base-palette-cantaloupe-100";
export const cantaloupe200 = "--cnvs-base-palette-cantaloupe-200";
export const cantaloupe300 = "--cnvs-base-palette-cantaloupe-300";
export const cantaloupe400 = "--cnvs-base-palette-cantaloupe-400";
export const cantaloupe500 = "--cnvs-base-palette-cantaloupe-500";
export const cantaloupe600 = "--cnvs-base-palette-cantaloupe-600";
export const sourLemon100 = "--cnvs-base-palette-sour-lemon-100";
export const sourLemon200 = "--cnvs-base-palette-sour-lemon-200";
export const sourLemon300 = "--cnvs-base-palette-sour-lemon-300";
export const sourLemon400 = "--cnvs-base-palette-sour-lemon-400";
export const sourLemon500 = "--cnvs-base-palette-sour-lemon-500";
export const sourLemon600 = "--cnvs-base-palette-sour-lemon-600";
export const juicyPear100 = "--cnvs-base-palette-juicy-pear-100";
export const juicyPear200 = "--cnvs-base-palette-juicy-pear-200";
export const juicyPear300 = "--cnvs-base-palette-juicy-pear-300";
export const juicyPear400 = "--cnvs-base-palette-juicy-pear-400";
export const juicyPear500 = "--cnvs-base-palette-juicy-pear-500";
export const juicyPear600 = "--cnvs-base-palette-juicy-pear-600";
export const kiwi100 = "--cnvs-base-palette-kiwi-100";
export const kiwi200 = "--cnvs-base-palette-kiwi-200";
export const kiwi300 = "--cnvs-base-palette-kiwi-300";
export const kiwi400 = "--cnvs-base-palette-kiwi-400";
export const kiwi500 = "--cnvs-base-palette-kiwi-500";
export const kiwi600 = "--cnvs-base-palette-kiwi-600";
export const greenApple100 = "--cnvs-base-palette-green-apple-100";
export const greenApple200 = "--cnvs-base-palette-green-apple-200";
export const greenApple300 = "--cnvs-base-palette-green-apple-300";
export const greenApple400 = "--cnvs-base-palette-green-apple-400";
export const greenApple500 = "--cnvs-base-palette-green-apple-500";
export const greenApple600 = "--cnvs-base-palette-green-apple-600";
export const watermelon100 = "--cnvs-base-palette-watermelon-100";
export const watermelon200 = "--cnvs-base-palette-watermelon-200";
export const watermelon300 = "--cnvs-base-palette-watermelon-300";
export const watermelon400 = "--cnvs-base-palette-watermelon-400";
export const watermelon500 = "--cnvs-base-palette-watermelon-500";
export const watermelon600 = "--cnvs-base-palette-watermelon-600";
export const jewel100 = "--cnvs-base-palette-jewel-100";
export const jewel200 = "--cnvs-base-palette-jewel-200";
export const jewel300 = "--cnvs-base-palette-jewel-300";
export const jewel400 = "--cnvs-base-palette-jewel-400";
export const jewel500 = "--cnvs-base-palette-jewel-500";
export const jewel600 = "--cnvs-base-palette-jewel-600";
export const toothpaste100 = "--cnvs-base-palette-toothpaste-100";
export const toothpaste200 = "--cnvs-base-palette-toothpaste-200";
export const toothpaste300 = "--cnvs-base-palette-toothpaste-300";
export const toothpaste400 = "--cnvs-base-palette-toothpaste-400";
export const toothpaste500 = "--cnvs-base-palette-toothpaste-500";
export const toothpaste600 = "--cnvs-base-palette-toothpaste-600";
export const blueberry100 = "--cnvs-base-palette-blueberry-100";
export const blueberry200 = "--cnvs-base-palette-blueberry-200";
export const blueberry300 = "--cnvs-base-palette-blueberry-300";
export const blueberry400 = "--cnvs-base-palette-blueberry-400";
export const blueberry500 = "--cnvs-base-palette-blueberry-500";
export const blueberry600 = "--cnvs-base-palette-blueberry-600";
export const plum100 = "--cnvs-base-palette-plum-100";
export const plum200 = "--cnvs-base-palette-plum-200";
export const plum300 = "--cnvs-base-palette-plum-300";
export const plum400 = "--cnvs-base-palette-plum-400";
export const plum500 = "--cnvs-base-palette-plum-500";
export const plum600 = "--cnvs-base-palette-plum-600";
export const berrySmoothie100 = "--cnvs-base-palette-berry-smoothie-100";
export const berrySmoothie200 = "--cnvs-base-palette-berry-smoothie-200";
export const berrySmoothie300 = "--cnvs-base-palette-berry-smoothie-300";
export const berrySmoothie400 = "--cnvs-base-palette-berry-smoothie-400";
export const berrySmoothie500 = "--cnvs-base-palette-berry-smoothie-500";
export const berrySmoothie600 = "--cnvs-base-palette-berry-smoothie-600";
export const blackberry100 = "--cnvs-base-palette-blackberry-100";
export const blackberry200 = "--cnvs-base-palette-blackberry-200";
export const blackberry300 = "--cnvs-base-palette-blackberry-300";
export const blackberry400 = "--cnvs-base-palette-blackberry-400";
export const blackberry500 = "--cnvs-base-palette-blackberry-500";
export const blackberry600 = "--cnvs-base-palette-blackberry-600";
export const islandPunch100 = "--cnvs-base-palette-island-punch-100";
export const islandPunch200 = "--cnvs-base-palette-island-punch-200";
export const islandPunch300 = "--cnvs-base-palette-island-punch-300";
export const islandPunch400 = "--cnvs-base-palette-island-punch-400";
export const islandPunch500 = "--cnvs-base-palette-island-punch-500";
export const islandPunch600 = "--cnvs-base-palette-island-punch-600";
export const grapeSoda100 = "--cnvs-base-palette-grape-soda-100";
export const grapeSoda200 = "--cnvs-base-palette-grape-soda-200";
export const grapeSoda300 = "--cnvs-base-palette-grape-soda-300";
export const grapeSoda400 = "--cnvs-base-palette-grape-soda-400";
export const grapeSoda500 = "--cnvs-base-palette-grape-soda-500";
export const grapeSoda600 = "--cnvs-base-palette-grape-soda-600";
export const pomegranate100 = "--cnvs-base-palette-pomegranate-100";
export const pomegranate200 = "--cnvs-base-palette-pomegranate-200";
export const pomegranate300 = "--cnvs-base-palette-pomegranate-300";
export const pomegranate400 = "--cnvs-base-palette-pomegranate-400";
export const pomegranate500 = "--cnvs-base-palette-pomegranate-500";
export const pomegranate600 = "--cnvs-base-palette-pomegranate-600";
export const fruitPunch100 = "--cnvs-base-palette-fruit-punch-100";
export const fruitPunch200 = "--cnvs-base-palette-fruit-punch-200";
export const fruitPunch300 = "--cnvs-base-palette-fruit-punch-300";
export const fruitPunch400 = "--cnvs-base-palette-fruit-punch-400";
export const fruitPunch500 = "--cnvs-base-palette-fruit-punch-500";
export const fruitPunch600 = "--cnvs-base-palette-fruit-punch-600";
export const rootBeer100 = "--cnvs-base-palette-root-beer-100";
export const rootBeer200 = "--cnvs-base-palette-root-beer-200";
export const rootBeer300 = "--cnvs-base-palette-root-beer-300";
export const rootBeer400 = "--cnvs-base-palette-root-beer-400";
export const rootBeer500 = "--cnvs-base-palette-root-beer-500";
export const rootBeer600 = "--cnvs-base-palette-root-beer-600";
export const toastedMarshmallow100 = "--cnvs-base-palette-toasted-marshmallow-100";
export const toastedMarshmallow200 = "--cnvs-base-palette-toasted-marshmallow-200";
export const toastedMarshmallow300 = "--cnvs-base-palette-toasted-marshmallow-300";
export const toastedMarshmallow400 = "--cnvs-base-palette-toasted-marshmallow-400";
export const toastedMarshmallow500 = "--cnvs-base-palette-toasted-marshmallow-500";
export const toastedMarshmallow600 = "--cnvs-base-palette-toasted-marshmallow-600";
export const coconut100 = "--cnvs-base-palette-coconut-100";
export const coconut200 = "--cnvs-base-palette-coconut-200";
export const coconut300 = "--cnvs-base-palette-coconut-300";
export const coconut400 = "--cnvs-base-palette-coconut-400";
export const coconut500 = "--cnvs-base-palette-coconut-500";
export const coconut600 = "--cnvs-base-palette-coconut-600";
export const cappuccino100 = "--cnvs-base-palette-cappuccino-100";
export const cappuccino200 = "--cnvs-base-palette-cappuccino-200";
export const cappuccino300 = "--cnvs-base-palette-cappuccino-300";
export const cappuccino400 = "--cnvs-base-palette-cappuccino-400";
export const cappuccino500 = "--cnvs-base-palette-cappuccino-500";
export const cappuccino600 = "--cnvs-base-palette-cappuccino-600";
export const licorice100 = "--cnvs-base-palette-licorice-100";
export const licorice200 = "--cnvs-base-palette-licorice-200";
export const licorice300 = "--cnvs-base-palette-licorice-300";
export const licorice400 = "--cnvs-base-palette-licorice-400";
export const licorice500 = "--cnvs-base-palette-licorice-500";
export const licorice600 = "--cnvs-base-palette-licorice-600";
export const soap100 = "--cnvs-base-palette-soap-100";
export const soap200 = "--cnvs-base-palette-soap-200";
export const soap300 = "--cnvs-base-palette-soap-300";
export const soap400 = "--cnvs-base-palette-soap-400";
export const soap500 = "--cnvs-base-palette-soap-500";
export const soap600 = "--cnvs-base-palette-soap-600";
export const frenchVanilla100 = "--cnvs-base-palette-french-vanilla-100";
export const frenchVanilla200 = "--cnvs-base-palette-french-vanilla-200";
export const frenchVanilla300 = "--cnvs-base-palette-french-vanilla-300";
export const frenchVanilla400 = "--cnvs-base-palette-french-vanilla-400";
export const frenchVanilla500 = "--cnvs-base-palette-french-vanilla-500";
export const frenchVanilla600 = "--cnvs-base-palette-french-vanilla-600";
export const blackPepper100 = "--cnvs-base-palette-black-pepper-100";
export const blackPepper200 = "--cnvs-base-palette-black-pepper-200";
export const blackPepper300 = "--cnvs-base-palette-black-pepper-300";
export const blackPepper400 = "--cnvs-base-palette-black-pepper-400";
export const blackPepper500 = "--cnvs-base-palette-black-pepper-500";
export const blackPepper600 = "--cnvs-base-palette-black-pepper-600";
export const opacity100 = "--cnvs-base-opacity-100";
export const opacity200 = "--cnvs-base-opacity-200";
export const opacity300 = "--cnvs-base-opacity-300";
export const opacity400 = "--cnvs-base-opacity-400";
export const opacity500 = "--cnvs-base-opacity-500";
export const fontSize25 = "--cnvs-base-font-size-25";
export const fontSize50 = "--cnvs-base-font-size-50";
export const fontSize75 = "--cnvs-base-font-size-75";
export const fontSize100 = "--cnvs-base-font-size-100";
export const fontSize125 = "--cnvs-base-font-size-125";
export const fontSize150 = "--cnvs-base-font-size-150";
export const fontSize200 = "--cnvs-base-font-size-200";
export const fontSize250 = "--cnvs-base-font-size-250";
export const fontSize300 = "--cnvs-base-font-size-300";
export const fontSize400 = "--cnvs-base-font-size-400";
export const fontSize500 = "--cnvs-base-font-size-500";
export const fontSize600 = "--cnvs-base-font-size-600";
export const fontSize750 = "--cnvs-base-font-size-750";
export const fontSize900 = "--cnvs-base-font-size-900";
export const fontSize1050 = "--cnvs-base-font-size-1050";
export const lineHeight50 = "--cnvs-base-line-height-50";
export const lineHeight100 = "--cnvs-base-line-height-100";
export const lineHeight150 = "--cnvs-base-line-height-150";
export const lineHeight200 = "--cnvs-base-line-height-200";
export const lineHeight250 = "--cnvs-base-line-height-250";
export const lineHeight300 = "--cnvs-base-line-height-300";
export const lineHeight350 = "--cnvs-base-line-height-350";
export const lineHeight400 = "--cnvs-base-line-height-400";
export const lineHeight500 = "--cnvs-base-line-height-500";
export const lineHeight600 = "--cnvs-base-line-height-600";
export const lineHeight750 = "--cnvs-base-line-height-750";
export const lineHeight900 = "--cnvs-base-line-height-900";
export const lineHeight1050 = "--cnvs-base-line-height-1050";
export const fontFamily50 = "--cnvs-base-font-family-50";
export const fontFamily100 = "--cnvs-base-font-family-100";
export const fontFamily200 = "--cnvs-base-font-family-200";
export const fontWeight300 = "--cnvs-base-font-weight-300";
export const fontWeight400 = "--cnvs-base-font-weight-400";
export const fontWeight500 = "--cnvs-base-font-weight-500";
export const fontWeight700 = "--cnvs-base-font-weight-700";
export const letterSpacing50 = "--cnvs-base-letter-spacing-50";
export const letterSpacing100 = "--cnvs-base-letter-spacing-100";
export const letterSpacing150 = "--cnvs-base-letter-spacing-150";
export const letterSpacing200 = "--cnvs-base-letter-spacing-200";
export const extendedDragonFruit100 = "--cnvs-base-extended-palette-dragon-fruit-100";
export const extendedDragonFruit200 = "--cnvs-base-extended-palette-dragon-fruit-200";
export const extendedDragonFruit300 = "--cnvs-base-extended-palette-dragon-fruit-300";
export const extendedDragonFruit400 = "--cnvs-base-extended-palette-dragon-fruit-400";
export const extendedDragonFruit500 = "--cnvs-base-extended-palette-dragon-fruit-500";
export const extendedDragonFruit600 = "--cnvs-base-extended-palette-dragon-fruit-600";
export const baseUnit = "--cnvs-base-unit";
